import {Injectable} from '@angular/core';
import {Http, URLSearchParams} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class ArticlesService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);

    this.loader.next(true); // init custom loader
  }

  getArticle(id: number) {
    const url = this.Routing.generate('api_get_article', {'_format': 'json', 'article': id}, true);
    const params = new URLSearchParams();

    return this.http
      // .get(`${url}/${id}`, {search: params, headers: this.updateHeaders()})
      .get(`${url}`, {search: params, headers: this.updateHeaders()})
      .map(response => response.json().data);
  }

  updateArticlePrice(article) {
    const url = this.Routing.generate('api_patch_article', {'_format': 'json', 'article': article.id}, true);

    return this.http
      // .patch(`${url}/${article.id}`, JSON.stringify({prixVente: article.prixVente}), {headers: this.updateHeaders()})
      .patch(`${url}`, JSON.stringify({prixVente: article.prixVente}), {headers: this.updateHeaders()})
      .map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/articles.service.ts